import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import CentroCostosTable from '../../components/Exportacion/CentroCostosTable';
import { CentroCostosExportService } from '../../services/CentroCostosExportService';

const CentroCostosExportPage = () => {
  const [centrosCosto, setCentrosCosto] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [exportError, setExportError] = useState(null);
  const exportErrorRef = useRef(null);

  useEffect(() => {
    loadCentrosCosto();
  }, []);

  // Scroll al error de exportación cuando aparezca
  useEffect(() => {
    if (exportError && exportErrorRef.current) {
      exportErrorRef.current.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
    }
  }, [exportError]);

  const loadCentrosCosto = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await CentroCostosExportService.getCentrosCosto();
      setCentrosCosto(data);
    } catch (err) {
      setError(err.message || 'Error al cargar centros de costo');
    } finally {
      setLoading(false);
    }
  };

  const handleExport = async (centroCostoId) => {
    try {
      setExportError(null); // Limpiar error anterior
      await CentroCostosExportService.exportCentroCosto(centroCostoId);
    } catch (err) {
      setExportError(err.message || 'Error al exportar centro de costo');
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs maintitle="Dashboard" title="Exportación" breadcrumbItem="Centro de Costos" />
        <Row>
          <Col lg="12">
            <Card>
              <CardHeader>
                <h4 className="card-title mb-0">Centro de Costos - Exportación</h4>
              </CardHeader>
              <CardBody>
                {exportError && (
                  <div ref={exportErrorRef} className="alert alert-warning mb-3" role="alert">
                    {exportError}
                  </div>
                )}
                <CentroCostosTable
                  centrosCosto={centrosCosto}
                  onExport={handleExport}
                  loading={loading}
                  error={error}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CentroCostosExportPage;
